<template>
  <time
    :title="applyFilter('dd/MM/yyyy HH:mm')"
    :datetime="timestampNormalized.toISOString()"
  >
    {{ applyFilter() }}
  </time>
</template>

<script>
import { defineComponent } from 'vue'
import { format, formatDistanceToNow, formatDistanceToNowStrict, formatDistanceStrict, differenceInCalendarDays } from 'date-fns'
import availables from '@/vendors/i18n/translations/available'
import en from 'date-fns/locale/en-US'
import fr from 'date-fns/locale/fr'
import nl from 'date-fns/locale/nl'
import de from 'date-fns/locale/de'
import it from 'date-fns/locale/it'

export default defineComponent({
  props: {
    timestamp: {
      required: true
    },
    filter: {
      type: String,
      default: 'formatDistanceToNow'
    }
  },
  data () {
    return {
      en,
      fr,
      nl,
      de,
      it,
      dateFormats: [
        'dd.MM.yy',
        'HH:mm',
        'dd/MM/yyyy',
        'yyyy/MM/dd',
        'dd/MM/yyyy HH:mm',
        'dd/MM/yyyy – HH:mm',
        'yyyy',
        'dd MMMM Y',
        'EEEE, dd MMMM yyyy HH:mm',
        'EEE dd MMM yyyy HH:mm',
        'EEEE, dd MMMM yyyy',
        'EEE dd MMM yyyy'
      ]
    }
  },
  computed: {
    timestampNormalized () {
      return new Date(this.timestamp)
    },
    getLocale () {
      const language = Object.values(availables).find((language) => language.id === this.$i18n.locale)
      return this[language.value]
    }
  },
  methods: {
    applyFilter (fltr) {
      const filter = fltr || this.filter
      if (filter === 'formatDistanceStrict') {
        return formatDistanceStrict(this.timestampNormalized, new Date(), { unit: 'day', locale: this.getLocale })
      } else if (filter === 'formatDistanceToNowStrict') {
        return formatDistanceToNowStrict(this.timestampNormalized, { locale: this.getLocale, addSuffix: true })
      } else if (filter === 'differenceInCalendarDays') {
        return Math.max(0, differenceInCalendarDays(this.timestampNormalized, new Date()))
      } else if (this.dateFormats.includes(filter)) {
        return format(this.timestampNormalized, filter, { locale: this.getLocale })
      } else {
        return formatDistanceToNow(this.timestampNormalized, { locale: this.getLocale })
      }
    }
  }
})
</script>
